module.exports = __webpack_public_path__ + "static/2front-ux-1-d63d5507e03037cad58718faf71e34e2.png";